import { QuetzalitoFab } from "./fab";
import { QuetzalitoPanel } from "./panel";

let initialized = false;

/** Monta la burbuja flotante de Quetzalito una sola vez, fuera de #app-router-outlet, para que sobreviva a cada navegación. */
export function initQuetzalitoChat(): void {
  if (initialized) return;
  initialized = true;

  const panel = new QuetzalitoPanel((open) => {
    if (open) fab.hide();
    else fab.show();
  });
  const fab = new QuetzalitoFab({
    openChat: () => void panel.toggle(),
    newConversation: () => void panel.startNewConversation(),
    showHistory: () => void panel.showConversationHistory(),
  });
}
